import './InlineLoader.scss'
import React from 'react'

const InlineLoader = (props) => {
    return props.isShow ? (
        <div className='lds-ellipsis'>
            <div style={props.color ? { background: props.color } : null}></div>
            <div style={props.color ? { background: props.color } : null}></div>
            <div style={props.color ? { background: props.color } : null}></div>
            <div style={props.color ? { background: props.color } : null}></div>
        </div>
    ) : null;
}

export default InlineLoader
